var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var _a;
import { jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import PropTypes from "prop-types";
import { withTheme } from "styled-components";
const Line = withTheme((_a = class extends PureComponent {
  render() {
    const {
      path,
      stroke,
      strokeWidth,
      fill,
      className,
      theme
    } = this.props;
    return /* @__PURE__ */ jsx("path", { d: path, stroke: stroke || theme.constellation.colors.blue500, strokeWidth, fill, className });
  }
}, __publicField(_a, "propTypes", {
  className: PropTypes.string,
  fill: PropTypes.string,
  path: PropTypes.string.isRequired,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.number,
  theme: PropTypes.object
}), __publicField(_a, "defaultProps", {
  strokeWidth: 1.5,
  fill: "none",
  className: "rd3-linechart-path"
}), _a));
export {
  Line as default
};
